/**
 * Admin user identity (domain layer).
 * Encodes the routing state machine from the design doc.
 */

export interface AdminUser {
  id: string;
  email: string;
  is_staff: boolean;
  is_admin: boolean;
  is_superuser: boolean;
  groups: string[];
}

export type AdminRoute = 'login' | 'forbidden' | 'app';

export const resolveRoute = (user: AdminUser | null): AdminRoute => {
  if (!user) return 'login';
  if (!user.is_staff) return 'forbidden';
  if (user.is_superuser) return 'app';
  if (user.is_admin) return 'app';
  if (user.groups.some((g) => ADMIN_GROUPS.has(g))) return 'app';
  return 'forbidden';
};

export const ADMIN_GROUPS = new Set(['Billing Admin', 'Support', 'Read-only Auditor']);
export const WRITE_GROUPS = new Set(['Billing Admin', 'Support']);

export const canMutate = (user: AdminUser | null): boolean => {
  if (!user) return false;
  if (user.is_superuser) return true;
  return user.groups.some((g) => WRITE_GROUPS.has(g));
};
